import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Sobre el Hotel */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              Hotel <span className="text-amber-400">Montecarlo</span>
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Un lugar tranquilo y silencioso para relajarse en el corazón de Caldera - Bahía Inglesa, Región de Atacama, Chile.
            </p>
            
            {/* ICONOS SOCIALES ACTUALIZADOS */}
            <div className="flex gap-4 mt-6">
              <a 
                href="https://www.facebook.com/HotelMontecarloCaldera/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/hotel_montecarlo_caldera/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-amber-600 transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h3 className="text-xl font-bold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-left w-full"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('rooms')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-left w-full"
                >
                  Habitaciones
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-left w-full"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('attractions')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-left w-full"
                >
                  Atractivos
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-left w-full"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Información de Contacto */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-amber-400 mt-1 flex-shrink-0" />
                <span className="text-gray-400">
                  Carvallo 627 <br />
                  Caldera, Atacama, Chile
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-amber-400 mt-1 flex-shrink-0" />
                <div className="text-gray-400">
                  <a href="tel:+56522315388" className="block whitespace-nowrap hover:text-amber-400 transition-colors">
                    +56 52 2315388
                  </a>
                  <a href="tel:+56961964694" className="block whitespace-nowrap hover:text-amber-400 transition-colors">
                    +56 9 61964694
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-amber-400 mt-1 flex-shrink-0" />
                <div className="text-gray-400 flex flex-col gap-1">
                  <a
                    href="mailto:reserva@hotel-montecarlo.cl"
                    className="whitespace-nowrap hover:text-amber-400 transition-colors"
                  >
                    reserva@hotel-montecarlo.cl
                  </a>
                  <a
                    href="mailto:hotel.montecarloatacama@gmail.com"
                    className="whitespace-nowrap hover:text-amber-400 transition-colors"
                  >
                    hotel.montecarloatacama@gmail.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="text-center space-y-2">
            <p className="text-gray-400 text-sm">
              &copy; {currentYear} Hotel Montecarlo. Todos los derechos reservados.
            </p>
            <p className="text-gray-500 text-xs">
              Desarrollado por{' '}
              <a
                href="https://www.avcsoluciones.cl"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-amber-400 transition-colors"
              >
                AVC Soluciones
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;